export const NAMESPACE = 'SUBSCRIPTIONS/';
export const DELETE = `${NAMESPACE}DELETE`;
export const FETCH = `${NAMESPACE}FETCH`;
export const SET_PARAMS = `${NAMESPACE}SET_PARAMS`;
export const RESET = `${NAMESPACE}RESET`;
export const QUOTA = `${NAMESPACE}QUOTA`;
